"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dynamicStyles = exports.iconButtonStyles = void 0;

var _react = require("@emotion/react");

var _elements = require("../../styles/elements");

var _util = require("../../util");

var base = /*#__PURE__*/(0, _react.css)("&>svg{width:", (0, _util.rem)(24), ";height:", (0, _util.rem)(24), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:base;"));
var smallStyle = /*#__PURE__*/(0, _react.css)("&>svg{width:", (0, _util.rem)(16), ";height:", (0, _util.rem)(16), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:smallStyle;"));
var iconOnlyStyle = /*#__PURE__*/(0, _react.css)("padding-left:", (0, _util.rem)(7), ";padding-right:", (0, _util.rem)(7), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:iconOnlyStyle;"));
var smallAndIconOnly = /*#__PURE__*/(0, _react.css)("padding-left:", (0, _util.rem)(5), ";padding-right:", (0, _util.rem)(5), ";border-radius:", (0, _util.rem)(6), ";svg{width:", (0, _util.rem)(20), ";height:", (0, _util.rem)(20), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:smallAndIconOnly;"));
var noIcon = /*#__PURE__*/(0, _react.css)("svg{margin-left:-", (0, _util.rem)(4), ";&+span{margin-left:", (0, _util.rem)(6), ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:noIcon;"));

var iconButton = function iconButton(theme, active) {
  return /*#__PURE__*/(0, _react.css)(_elements.button.styles.preflight, ";z-index:1;color:", theme.color.monochrome.mediumDark, ";flex-shrink:0;svg{vertical-align:middle;}&:disabled{cursor:default;pointer-events:none;opacity:0.5;}&:not(:disabled)::before{content:'';display:block;opacity:0;position:absolute;transition-duration:0.15s;transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);bottom:0;left:0;right:0;top:0;z-index:-1;background:", theme.color.monochrome.light, ";transform:scale(0);transition-property:transform,opacity;border-radius:4px;}&:hover{", !active && /*#__PURE__*/(0, _react.css)("color:", theme.color.monochrome.dark, ";&::before{transform:scale(1);opacity:1;}" + (process.env.NODE_ENV === "production" ? "" : ";label:iconButton;")), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:iconButton;"));
};

var iconBig = function iconBig(theme) {
  return /*#__PURE__*/(0, _react.css)("width:", theme.spacing[16], ";height:", theme.spacing[16], ";svg{width:", theme.spacing[12], ";height:", theme.spacing[12], ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:iconBig;"));
};

var iconSmall = function iconSmall(theme) {
  return /*#__PURE__*/(0, _react.css)("width:", theme.spacing[14], ";height:", theme.spacing[14], ";svg{width:", theme.spacing[11], ";height:", theme.spacing[11], ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:iconSmall;"));
};

var iconButtonSizes = {
  big: iconBig,
  small: iconSmall
};

var iconButtonStyles = function iconButtonStyles(_ref) {
  var theme = _ref.theme,
      size = _ref.size,
      active = _ref.active;
  return /*#__PURE__*/(0, _react.css)(iconButton(theme, active), ";", iconButtonSizes[size](theme), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:iconButtonStyles;"));
};

exports.iconButtonStyles = iconButtonStyles;

var dynamicStyles = function dynamicStyles(_ref2) {
  var theme = _ref2.theme,
      size = _ref2.size,
      btnType = _ref2.btnType,
      iconOnly = _ref2.iconOnly;
  return /*#__PURE__*/(0, _react.css)(_elements.button.styles[btnType](theme), " ", _elements.button.sizes[size](theme), ";", base, ";", size === 'small' && smallStyle, ";", iconOnly && iconOnlyStyle, ";", size === 'small' && iconOnly && smallAndIconOnly, ";", !iconOnly && noIcon, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:dynamicStyles;"));
};

exports.dynamicStyles = dynamicStyles;
//# sourceMappingURL=Button.styles.js.map